var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.7,
    height: 25,
    viewBox: "0 0 22.7 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.5;}.b{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.8,16.5H22.9a2.3,2.3,0,0,1,2.3,2.3v8.05a2.3,2.3,0,0,1-2.3,2.3H6.8a2.3,2.3,0,0,1-2.3-2.3V18.8A2.3,2.3,0,0,1,6.8,16.5Z",
    transform: "translate(0 -3.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.5,13.35V8.75a5.75,5.75,0,0,1,11.5,0v4.6",
    transform: "translate(-1.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.482e8184e84697fa3c37a7a1bea19df5.svg";
export { ForwardRef as ReactComponent };